import React, { useState, useEffect } from "react";
import { Input, Button } from "semantic-ui-react";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import { Field as Fieldmik } from "formik";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import { DateData } from "../dynamicComponent/datepick";
import ReactFileReader from "react-file-reader";
import { values } from "lodash";
import { PostFilesAxios, GetFilesAxiosPDF } from "../axiosComponent/fileHandleAxiosCall";
import cogoToast from "cogo-toast";

const UploadDO = ({ field: { name }, form: { setFieldValue }, ...props }) => {
  useEffect(() => {
  }, []);

  const [uploadedFileName, setUploadedFileName] = useState(props.bookingRequestObj?.booking_deliveries?.[0]?.delivery_order?.document_name ? props.bookingRequestObj?.booking_deliveries?.[0]?.delivery_order?.document_name : '');


  const handleFiles = (files) => {
    let data = {
      delivery_order: files.fileList[0],
    };
    PostFilesAxios({
      url: `/bookings/${props.bookingRequestObj.booking_deliveries[0].booking_delivery_id}/doDocument`,
      createItems: data,

    })
      .then((res) => {
        setFieldValue(name, files);
        if (res.data)
          setUploadedFileName(res.data.documentDetails[0].file_name)
        cogoToast.success('Uploaded Success');
      })
      .catch((err) => { console.log(err); cogoToast.error(err); })
  };

  const handleDownload = () => {

    GetFilesAxiosPDF({
      url: `/bookings/${props.bookingRequestObj.booking_deliveries[0].booking_delivery_id}/documents/${props.bookingRequestObj.booking_deliveries[0].delivery_order.document_id}`,

    })
      .then((res) => {
        var blob = new Blob([res.data]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = (props?.bookingRequestObj?.movement_type && props.bookingRequestObj.movement_type == 'import') ? "downloadCRO.pdf" : "downloadDO.pdf";
        link.click();
      })
      .catch((err) => { console.log(err); cogoToast.error(err); })
  }

  return (
    <div className="ui action display-flex-center-justify-spacebtwn">
      <div className="do-group-container">
        <Fieldmik disabled={props.disabled} component={MyNormalInput} name="DO_no" className="do-group-container-input" />
      </div>

      <div className="do-group-container-big">
        <DateData
          disabled={props.disabled}
          name="DO_validity_date"
          autoComplete="off"
          //showTimeSelect
          //timeFormat="hh:mm"
          popperClassName="dateTime"

          dateFormat="dd/MM/yyyy"
          timeIntervals={5}
          customInput={
            <Input icon="time" className="poupDate" iconPosition="left" />
          }
        />
      </div>
      {props.mode == "edit" || props.mode == "view" ?
        <div className="do-group-container">
          <div className="width-100cent display-flex-center-justify-spacebtwn flex-wrap">
            <div className="display-flex-center-justify-spacebtwn">
              <ReactFileReader
                disabled={props.mode == "view"}
                base64={true}
                fileTypes={[".pdf", ".xls", ".xlsx"]}
                handleFiles={handleFiles}
                {...props}
              >
                <button type="button" className={props.className}>
                  <i className="fas fa-upload"></i> {props.buttonName}
                </button>
              </ReactFileReader>
              {props.bookingRequestObj?.booking_deliveries?.[0]?.delivery_order?.document_name ?
                <button target="_blank" type="button" className={props.className} onClick={handleDownload}>
                  <i className="fas fa-download"></i> {props.buttonName}
                </button>
                :
                null}
            </div>
            <div style={{ width: "120px" }}>
              <p>{uploadedFileName}</p>
            </div>
            {/* <button onClick={handleDownload}>
              <i class="fas fa-download"></i>
            </button> */}
          </div>
          {/* <div>
            {props.values?.delivery_order?.document_name}
          </div> */}
        </div>
        : null}

    </div>
  );
};

export default UploadDO;
